{
  "app": {
    "eyebrow": "Unofficial Morimens tool",
    "title": "Morimen Team Builder",
    "metaDescription": "A fast, unofficial ten-team builder for Morimens.",
    "about": "Data",
    "switchToChinese": "Switch to Simplified Chinese",
    "switchToEnglish": "Switch to English",
    "chineseShort": "中",
    "englishShort": "EN",
    "footer": "Noncommercial fan project · Not affiliated with Qookka Games",
    "attribution": "SKeyDB attribution & asset notice"
  },
  "navigation": {
    "label": "Primary navigation",
    "builder": "Team Builder",
    "recommended": "Recommended Teams"
  },
  "builder": {
    "activeFormation": "Active formation · {{number}}",
    "teamName": "Team name",
    "rename": "Rename team",
    "chooseRealms": "Choose up to two realms",
    "realmCount": "{{count}}/2 realms",
    "import": "Import",
    "clear": "Clear",
    "clearNamed": "Clear {{name}}",
    "copyReady": "Copy a game-ready team code",
    "copy": "Copy code",
    "copied": "Copied",
    "copiedToast": "Team code copied to the clipboard.",
    "teamPosse": "Team posse",
    "choosePosse": "Choose a posse",
    "posseHint": "The team-wide action that anchors this formation.",
    "loadouts": "Awakener loadouts",
    "awakener": "Awakener",
    "chooseAwakener": "Choose awakener",
    "chooseAwakenerSlot": "Choose awakener for slot {{number}}",
    "awakenerSlotLabel": "Awakener slot {{number}}: {{name}}",
    "wheelNumber": "Wheel {{number}}",
    "chooseWheel": "Choose wheel",
    "chooseWheelSlot": "Choose wheel {{wheel}} for slot {{slot}}",
    "wheelSlotLabel": "Slot {{slot}}, wheel {{wheel}}: {{name}}",
    "chooseCovenant": "Choose covenant",
    "chooseCovenantSlot": "Choose covenant for slot {{number}}",
    "covenantSlotLabel": "Slot {{number}}, covenant: {{name}}",
    "posseSlotLabel": "Team posse: {{name}}",
    "empty": "Empty",
    "add": "Add",
    "lineupSet": "Lineup set",
    "teamCount": "10 teams",
    "reset": "Reset",
    "resetConfirm": "Reset all ten teams? You can undo this once.",
    "teamsLabel": "Ten teams",
    "defaultTeam": "Team {{number}}",
    "noPosse": "No posse",
    "tokenMissing": "Token missing",
    "railAwakeners": "Awakeners: {{names}}.",
    "railWheels": "Wheels: {{names}}.",
    "railPosse": "Posse: {{name}}."
  },
  "recommended": {
    "title": "Recommended teams",
    "slotLabel": "Recommended loadout slot {{number}}",
    "copy": "Copy code",
    "copied": "Copied",
    "copyFailed": "Clipboard access failed.",
    "covenant": "Covenant",
    "posse": "Posse",
    "emptyTitle": "No recommended teams yet",
    "emptyDescription": "Add a team to data/recommended-teams.json and rebuild the site."
  },
  "picker": {
    "emptyTitle": "Select a slot to begin.",
    "nowEditing": "Now editing",
    "close": "Close picker",
    "label": "{{target}} picker",
    "search": "Search names, aliases, or tags",
    "searchLabel": "Search records",
    "clearSearch": "Clear search",
    "primaryFilters": "Primary filters",
    "rarityFilters": "Rarity filters",
    "all": "All",
    "allRarity": "All rarity",
    "recordCount": "{{count}} records",
    "clearSlot": "Clear slot",
    "realmLimit": "Realm limit",
    "realmLimitDetail": "This awakener would exceed the two-realm limit.",
    "replace": "Replace",
    "planningOnly": "Planning only",
    "noResults": "No matching records."
  },
  "target": {
    "posse": "Posse",
    "awakener": "Awakener {{number}}",
    "wheel": "Slot {{slot}} · Wheel {{wheel}}",
    "covenant": "Slot {{slot}} · Covenant"
  },
  "import": {
    "format": "17-field game format",
    "title": "Import a team code",
    "description": "Paste a Morimens share code to preview the lineup and any cross-team moves.",
    "placeholder": "@@paste-code-here@@",
    "inputLabel": "Morimens share code",
    "close": "Close",
    "empty": "Empty",
    "noPosse": "No posse",
    "conflicts": "Conflicts to clear",
    "conflictItem": "{{entity}} from {{team}}",
    "noConflicts": "No cross-team conflicts.",
    "cancel": "Cancel",
    "confirm": "Import team",
    "preview": "Preview import"
  },
  "about": {
    "kicker": "Build provenance",
    "title": "Data, credits & usage",
    "close": "Close",
    "currentData": "Current data",
    "generated": "Generated {{date}}",
    "noncommercial": "Noncommercial fan project",
    "notAffiliated": "Not affiliated with or endorsed by Qookka Games.",
    "skeydbNotice": "Contains SKeyDB community data/content for Morimens, created by dansa and SKeyDB contributors. SKeyDB-original data is reused under CC BY-NC-SA 4.0. Game-owned names, art, text, and other materials remain the property of Qookka Games and/or their licensors.",
    "huijiNotice": "Some posse and historical artwork is attributed to the Morimens HuijiWiki community under its applicable terms.",
    "source": "View SKeyDB source",
    "counts": "{{awakeners}} awakeners · {{wheels}} wheels · {{covenants}} covenants · {{posses}} posses"
  },
  "toast": {
    "undo": "Undo",
    "dismiss": "Dismiss",
    "invalid": "That assignment is not valid.",
    "move": "Moved from its previous team. Undo is available.",
    "assigned": "Assigned.",
    "selectionRestored": "Assignment restored.",
    "clearedRestored": "Cleared selection restored.",
    "selectionCleared": "Selection cleared.",
    "teamRestored": "Team restored.",
    "teamCleared": "Team cleared.",
    "allRestored": "All teams restored.",
    "allReset": "All teams reset.",
    "importReverted": "Import reverted.",
    "imported": "Team imported. Conflicting placements were cleared.",
    "dataUpdated": "Game data updated. Saved teams were reconciled.",
    "copyFailed": "Clipboard access failed. Copy the code manually."
  },
  "errors": {
    "targetMissing": "Target team no longer exists.",
    "unknownCovenant": "Unknown covenant.",
    "unknownEntity": "Unknown entity.",
    "entityNotSelectable": "This compatibility-only entity cannot be newly selected.",
    "realmMove": "This move would exceed the two-realm limit.",
    "noToken": "No share-code token for {{names}}.",
    "invalidWrapper": "No valid @@share-code@@ payload was found.",
    "unknownAwakener": "Unknown or outdated awakener token.",
    "unknownWheel": "Unknown or outdated wheel token.",
    "unknownCovenantToken": "Unknown or outdated covenant token.",
    "unknownPosse": "Unknown or outdated posse token.",
    "trailingData": "The share code contains trailing or version-mismatched data.",
    "duplicateEntity": "The share code assigns the same unique entity more than once.",
    "importRealm": "The imported team exceeds the two-realm limit."
  },
  "enums": {
    "AEQUOR": "Aequor",
    "CARO": "Caro",
    "CHAOS": "Chaos",
    "ULTRA": "Ultra",
    "FADED_LEGACY": "Faded Legacy",
    "OTHER": "Other",
    "ALIEMUS_REGEN": "Aliemus Regen",
    "CRIT_DMG": "Crit DMG",
    "CRIT_RATE": "Crit Rate",
    "DEATH_RESISTANCE": "Death Resistance",
    "DMG_AMP": "DMG Amp",
    "KEYFLARE_REGEN": "Keyflare Regen",
    "REALM_MASTERY": "Realm Mastery",
    "SIGIL_YIELD": "Sigil Yield"
  }
}
